import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { Route, RouteComponentProps } from 'react-router-dom';
import { RoutePrefix } from '../../../Routes';
import { FormState } from '../../../components/Form';
import { RouteName } from '../@data';
import { onCurrentRouteChanged } from '../@data/actions';
import '../@data/orchestrators';
import './@data/mutators';
import './@data/orchestrators';
import { InviteUser } from './Invite/InviteUser';
import { ManagePage } from './Manage/ManagePage';

export const UserPage = injectIntl(function UserPageComponent({ match, intl }: RouteComponentProps & InjectedIntlProps): JSX.Element {
  React.useEffect(() => {
    onCurrentRouteChanged(RouteName.user, intl.formatMessage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <Route exact path={`${match.url}`} component={ManagePage} />
      <Route
        path={`/${RoutePrefix.partnerManagement}/:publisherId/${RouteName[RouteName.user]}/create`}
        render={(props) => <InviteUser {...props} mode={FormState.Create} />}
      />
      <Route
        path={`/${RoutePrefix.partnerManagement}/:publisherId/${RouteName[RouteName.user]}/edit/:id`}
        render={(props) => <InviteUser {...props} mode={FormState.Edit} />}
      />
    </React.Fragment>
  );
});
